export default __webpack_public_path__ + "static/media/855.444e3ea5.png";